import React, { useState } from "react";
import { Box, Typography, TextField, Link } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from '@mui/icons-material/Language';
import CustomFormAction from "../customComponents/CustomFormAction";
import CustomButton from "../customComponents/CustomButton";
import { z } from "zod";
import { IContactRequest } from "@ontime/types";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import ContactService from "../services/ContactService";
import LinkedInIcon from '@mui/icons-material/LinkedIn';


const contactSchema = z.object({
    name: z.string().min(2, "First name must be at least 2 characters").max(50),
    message: z.string().min(10, "Message must be at least 10 characters").max(50),
    email: z.string().email("Invalid email format"),
    phone: z.string().regex(/^\+?[1-9]\d{1,14}$/, "Invalid phone number format"),
    // recaptchaToken: z.string()
});

const ContactUs: React.FC = () => {

    const { register, handleSubmit, formState: { errors }, watch, setValue, reset } = useForm<IContactRequest>({
        resolver: zodResolver(contactSchema),
        defaultValues: {
            // recaptchaToken: "",

        }
    });

    const [loading, setLoading] = useState(false);


    const handleRegister = async (data: IContactRequest) => {
        setLoading(true);

        try {
            const response = await ContactService.Create({ ...data });
            if (response) {
                // enqueueSnackbar('Message sent', { variant: 'success' });
                reset()
            }
        } catch (error) {
            console.error(error, { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };


    return (
        <Box className="home-section"
            component="section"
            id="homeContactUs"
            sx={{
                p: 4,
                bgcolor: "#f9f9f9",
                display: "flex",
                flexDirection: "column",
                gap: 4,
            }}
        >
            <Typography variant="h4" align="center" sx={{ fontWeight: "bold", mb: 4, }} >
                Contact Us
            </Typography>
            <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                justifyContent={{ xs: "center", md: "space-evenly" }}
                alignItems='center'
                gap={4}
            >
                <Box sx={{ flex: 1, minWidth: 300, maxWidth: 400 }}>

                    <Box display="flex" flexDirection="column" gap={2}>
                        <Box>
                            <Typography variant="h6" fontWeight="bold" display='flex'>
                                Majid Ghajari
                                <Box ml={1} >
                                    <Link sx={{ color: 'text.primary' }} href="mailto:majidgdotcom@gmail.com" target="_blank">
                                        <EmailIcon />
                                    </Link>
                                    <Link sx={{ color: 'text.primary' }} href="https://www.linkedin.com/in/majidgdotcom/" target="_blank">
                                        <LinkedInIcon />
                                    </Link>
                                    <Link sx={{ color: 'text.primary' }} href="https://www.majidg.com" target="_blank">
                                        <LanguageIcon />
                                    </Link>
                                </Box>
                            </Typography>
                            <Typography variant="caption" fontWeight="bold">
                                Founder, Primary Developer
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant="h6" fontWeight="bold" display='flex'>
                                Neda Hajibabaei
                                <Box ml={1} >
                                    <Link sx={{ color: 'text.primary' }} href="mailto:n.hajibabaei88@gmail.com" target="_blank">
                                        <EmailIcon />
                                    </Link>
                                    <Link sx={{ color: 'text.primary' }} href="https://www.linkedin.com/in/neda-hajibabaei/" target="_blank">
                                        <LinkedInIcon />
                                    </Link>
                                </Box>
                            </Typography>
                            <Typography variant="caption" fontWeight="bold">
                                CEO, Frontend Developer
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant="h6" fontWeight="bold" display='flex'>
                                Mehrad Parsa
                                <Box ml={1} >
                                    <Link sx={{ color: 'text.primary' }} href="mailto:mehradparsa23@gmail.com" target="_blank">
                                        <EmailIcon />
                                    </Link>
                                </Box>
                            </Typography>
                            <Typography variant="caption" fontWeight="bold">
                                Support Specialist
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 300,
                        maxWidth: 400,
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >
                    <form onSubmit={handleSubmit(handleRegister)} noValidate>
                        <Box mt={2}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Name"
                                InputLabelProps={{ shrink: true }}
                                {...register('name')}
                                error={!!errors.name}
                                helperText={errors.name?.message}
                            />
                        </Box>

                        <Box mt={2}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Email"
                                InputLabelProps={{ shrink: true }}
                                {...register('email')}
                                error={!!errors.email}
                                helperText={errors.email?.message}
                            />
                        </Box>

                        <Box mt={2}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Phone"
                                InputLabelProps={{ shrink: true }}
                                {...register('phone')}
                                error={!!errors.phone}
                                helperText={errors.phone?.message}
                            />
                        </Box>

                        <Box mt={2}>
                            <TextField fullWidth label="Message" InputLabelProps={{ shrink: true }} multiline rows={3} {...register('message')} error={!!errors.message} helperText={errors.message?.message} />
                        </Box>
                        <CustomFormAction>
                            <CustomButton
                                lable={loading ? 'Sending...' : 'Send'}
                                type='submit'
                                disabled={loading}
                                infoContent={`Submit`}
                                size='medium'
                            />
                        </CustomFormAction>
                    </form>
                </Box>
            </Box>
        </Box>
    );
};

export default ContactUs;